import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {Index as IndexOrders} from './features/orders/order/Index';
import {Index as IndexDetails} from './features/orders/details/Index';
import {Index as IndexEnquiries}  from './features/enquiry/enquiries/Index';
import {Index as IndexEnquiryDetails}  from './features/enquiry/details/Index';
import {Index as IndexEnquiryCreate} from './features/enquiry/create/Index';
import {Index as IndexSupport} from './features/support/Index';
import {Index as IndexProjects}  from './features/projects/Index';
import {Index as IndexDashboard}  from './features/dashboard/Index';
import {Index as IndexMyHomepage}  from './features/myhomepage/Index';
import {Index as IndexAdmin} from './features/admin/Index';
import { FavButton } from './features/favourite/FavButton';
import { FavList } from './features/favourite/FavList';

const OrdersDivs = document.querySelectorAll('.bf-apps-orders')
OrdersDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexOrders attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const OrderDetailsDivs = document.querySelectorAll('.bf-apps-order-details')
OrderDetailsDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexDetails attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const EnquiriesDivs = document.querySelectorAll('.bf-apps-enquiries')
EnquiriesDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexEnquiries attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const EnquiryDetailsDivs = document.querySelectorAll('.bf-apps-enquiry-details')
EnquiryDetailsDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexEnquiryDetails attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const EnquiryCreateDivs = document.querySelectorAll('.bf-apps-enquiry-create')
EnquiryCreateDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexEnquiryCreate attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const ProjectDivs = document.querySelectorAll('.bf-apps-projects')
ProjectDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexProjects attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const DashboardDivs = document.querySelectorAll('.bf-apps-dashboard')
DashboardDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexDashboard attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const AdminIntegrationDivs = document.querySelectorAll('.bf-apps-admin')
AdminIntegrationDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexAdmin attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const SupportDivs = document.querySelectorAll('.bf-apps-support')
SupportDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexSupport attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const FavButtonDivs = document.querySelectorAll('.bf-apps-favbutton')
FavButtonDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <FavButton attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const FavListDivs = document.querySelectorAll('.bf-apps-favlist')
FavListDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <FavList attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

const MyHomepageDivs = document.querySelectorAll('.bf-apps-myhomepage')
MyHomepageDivs.forEach(node => {
  ReactDOM.render(
    <React.StrictMode>
      <IndexMyHomepage attributes={node.dataset} />
    </React.StrictMode>,
    node
  );
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
